// src/services/navigationService.ts

import apiClient from "../../admin/api/apiClient";

const API_PATH = process.env.REACT_APP_API_PATH;

// ==========================================
// TYPES
// ==========================================

export interface NavChild {

  subMenuID?: number;

  menuID?: number;

  subMenuName: string;

  subMenuUrl: string;

  targetType: "_self" | "_blank";

  status: "Active" | "Hidden";

  displayOrder: number;

  isActive: boolean;
}

export interface NavItem {

  menuID?: number;

  menuName: string;

  menuUrl: string;

  targetType: "_self" | "_blank";

  status: "Active" | "Hidden";

  displayOrder: number;

  isActive: boolean;

  navigationSubMenus: NavChild[];
}

// ==========================================
// API RESPONSE
// ==========================================

export interface ApiResponse<T> {

  isSuccess: boolean;

  message: string;

  data?: T;

  dataList?: T[];
}

// ==========================================
// NAVIGATION SERVICE
// ==========================================

const BASE_URL =
  "/Public";

export const navigationService = {

  // ==========================================
  // GET ALL
  // ==========================================

  getAll: async (): Promise<
    ApiResponse<NavItem>
  > => {

    const response =
      await apiClient.get(
        `${BASE_URL}/GetMenu`
      );

    return response.data;
  },

  // ==========================================
  // GET BY ID
  // ==========================================

  getById: async (
    id: number
  ): Promise<ApiResponse<NavItem>> => {

    const response =
      await apiClient.get(
        `${BASE_URL}/GetById/${id}`
      );

    return response.data;
  },

  // ==========================================
  // CREATE
  // ==========================================

  create: async (
    item: NavItem
  ): Promise<ApiResponse<NavItem>> => {

    const payload = {

      menuName:
        item.menuName,

      menuUrl:
        item.menuUrl,

      targetType:
        item.targetType,

      status:
        item.status,

      displayOrder:
        item.displayOrder,

      isActive:
        item.isActive,

      navigationSubMenus:
        item.navigationSubMenus.map(
          child => ({
            subMenuName:
              child.subMenuName,

            subMenuUrl:
              child.subMenuUrl,

            targetType:
              child.targetType,

            status:
              child.status,

            displayOrder:
              child.displayOrder,

            isActive:
              child.isActive,
          })
        ),
    };

    const response =
      await apiClient.post(
        `${BASE_URL}/Create`,
        payload
      );

    return response.data;
  },

  // ==========================================
  // UPDATE
  // ==========================================

  update: async (
    item: NavItem
  ): Promise<ApiResponse<NavItem>> => {

    const payload = {

      menuID:
        item.menuID,

      menuName:
        item.menuName,

      menuUrl:
        item.menuUrl,

      targetType:
        item.targetType,

      status:
        item.status,

      displayOrder:
        item.displayOrder,

      isActive:
        item.isActive,

      navigationSubMenus:
        item.navigationSubMenus.map(
          child => ({
            subMenuID:
              child.subMenuID,

            menuID:
              item.menuID,

            subMenuName:
              child.subMenuName,

            subMenuUrl:
              child.subMenuUrl,

            targetType:
              child.targetType,

            status:
              child.status,

            displayOrder:
              child.displayOrder,

            isActive:
              child.isActive,
          })
        ),
    };

    const response =
      await apiClient.put(
        `${BASE_URL}/Update`,
        payload
      );

    return response.data;
  },

  // ==========================================
  // DELETE
  // ==========================================

  delete: async (
    id: number
  ): Promise<ApiResponse<boolean>> => {

    const response =
      await apiClient.delete(
        `${BASE_URL}/Delete/${id}`
      );

    return response.data;
  },
};